// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

import { assertPath } from "./assert_path.ts";

export function stripSuffix(name: string, suffix: string): string {
  if (suffix.length >= name.length) {
    return name;
  }

  const lenDiff = name.length - suffix.length;

  for (let i = suffix.length - 1; i >= 0; --i) {
    if (name.charCodeAt(lenDiff + i) !== suffix.charCodeAt(i)) {
      return name;
    }
  }

  return name.slice(0, -suffix.length);
}

export function lastPathSegment(
  path: string,
  isSep: (char: number) => boolean,
  start = 0,
): string {
  let matchedNonSeparator = false;
  let end = path.length;

  for (let i = path.length - 1; i >= start; --i) {
    if (isSep(path.charCodeAt(i))) {
      if (matchedNonSeparator) {
        start = i + 1;
        break;
      }
    } else if (!matchedNonSeparator) {
      matchedNonSeparator = true;
      end = i + 1;
    }
  }

  return path.slice(start, end);
}

export function assertArgs(path: string, suffix: string) {
  assertPath(path);
  if (path.length === 0) return path;
  if (typeof suffix !== "string") {
    throw new TypeError(
      `Suffix must be a string, received "${JSON.stringify(suffix)}"`,
    );
  }
}

// denoCacheMetadata={"headers":{"x-goog-stored-content-encoding":"identity","server":"UploadServer","x-goog-storage-class":"STANDARD","x-guploader-uploadid":"AHmUCY2duWdYWOWmELfuXSrJxgpzK7amwPaAni6mPG2ty-EP1JuEkIOTj6vA8n_s6rhvXqImsfw","date":"Fri, 08 Nov 2024 09:21:07 GMT","cache-control":"public, max-age=31536000, immutable","x-jsr-cache-status":"hit","x-goog-generation":"1730457482705830","access-control-expose-headers":"*","cross-origin-resource-policy":"cross-origin","x-goog-metageneration":"1","age":"2934","content-type":"text/typescript","x-goog-hash":"crc32c=1a87dg==,md5=999qnL2zTPahdHMVypuirw==","last-modified":"Fri, 01 Nov 2024 10:38:02 GMT","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","etag":"\"f7df6a9cbdb34cf6a1747315ca9ba2af\"","x-jsr-cache-id":"IAD","expires":"Sat, 08 Nov 2025 09:21:07 GMT","access-control-allow-origin":"*","accept-ranges":"bytes","x-content-type-options":"nosniff","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","via":"1.1 google","x-goog-stored-content-length":"1264","x-robots-tag":"noindex","content-length":"1264"},"url":"https://jsr.io/@std/path/1.0.8/_common/basename.ts","time":1731060601}